import getLocal from '@/app/utils/getLocal';
import { FC } from 'react';
import PlugCommon from './PlugCommon';
import PlugIt from './PlugIt';

interface PlugProps {
    pageType: string;
}
const euPages = ['normal', 'ultra', 'ac'];

const Plug: FC<PlugProps> = ({ pageType = 'normal' }) => {
    const { locale = 'us' } = getLocal();

    return (
        <>
            {locale !== 'it' && (
                <>
                    <PlugCommon pageType={pageType} />
                </>
            )}
            {locale === 'it' && (
                <>
                    <PlugIt pageType={pageType} />
                </>
            )}
        </>
    );
};

export default Plug;
